export interface ShopEnv {
  supabaseUrl: string;
  supabaseAnonKey: string;
  /** URL of the operator app for SSO redirects + billing upsell links. */
  webAppUrl: string;
  /** URL of the vendor portal for cross-links. */
  sellAppUrl: string;
}

function required(name: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(
      `Missing required env var ${name}. Set it in apps/shop/.env.local or in the Netlify site settings.`,
    );
  }
  return value;
}

export const env: ShopEnv = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL as string),
  supabaseAnonKey: required(
    'VITE_SUPABASE_ANON_KEY',
    import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  ),
  webAppUrl:
    (import.meta.env.VITE_WEB_APP_URL as string | undefined) ??
    'https://app.peptideclients.com',
  sellAppUrl:
    (import.meta.env.VITE_SELL_APP_URL as string | undefined) ??
    'https://sell.peptideclients.com',
};
